export class CreateMarker {

    static openWindow = null; // aktuelles offene Info-Window global speichern
  
    static create(data, map, stage) { 

          
      let marker = document.createElement('div');
      marker.style.left = data.cords.x + '%';
      marker.style.top = data.cords.y + '%';

     

      switch (data.category[0].name) {
        case "stage":
            marker.className = 'cat-' + 'stage';
            break;
        default:
            marker.className = 'cat-' + data.category[0].name;
      }


      marker.classList.add('marker');
      marker.style.pointerEvents = 'auto';
  
      let mark = document.createElement('div');
      mark.className = "mark";
  
      let haus = document.createElement('div');
      haus.className= "marker__haus";

      const assetsTag = document.getElementById('marker-map-assets-json');
    
      
    
      const assets = assetsTag ? JSON.parse(assetsTag.textContent) : {};
    
    
    
      const cat = data.category[0].name;
      const cfg = assets[cat] || assets['default'] || {};

      
      if (cfg.haus) {
        haus.innerHTML = `<img src="${cfg.haus}">`;
        marker.appendChild(haus);
      }

      if (cfg.marker) {
        mark.innerHTML = `<img src="${cfg.marker}">`;
        marker.appendChild(mark);
      }
  
      // Info-Window
      let infoWindow = document.createElement('div');
      infoWindow.style.display = 'none';
      infoWindow.className = "info-window";
      
      // Build HTML content
      let contentHTML = data.html || '';
      

      
      // Add link button if headerLink exists
      if (data.headerLink) {
        const buttonClass = data.headerLink.isFile ? 'btn btn-download' : 'btn';
        const buttonText = data.headerLink.isFile ? 'Download' : 'Mehr Infos';
        
        contentHTML += `<br><a href="${data.headerLink.url}" class="${buttonClass}">${buttonText}</a>`;
      }
      
      
      infoWindow.innerHTML = contentHTML;
      infoWindow.style.zIndex = '1000';
      map.appendChild(infoWindow);



      // Klick auf Marker
      marker.addEventListener('click', (e) => {
 
        e.stopPropagation();
        e.preventDefault();
  
        // vorheriges Fenster schließen
        if (CreateMarker.openWindow && CreateMarker.openWindow !== infoWindow) {
          CreateMarker.openWindow.style.display = 'none';
        }

        const isOpen = infoWindow.style.display === 'block';
        if (isOpen) {
          infoWindow.style.display = 'none';
          CreateMarker.openWindow = null;
        } else {
          // sichtbar machen, aber unsichtbar, um Maße korrekt zu messen
          infoWindow.style.visibility = 'hidden';
          infoWindow.style.display = 'block';
          CreateMarker.positionInfoWindow(marker, infoWindow, stage, map);
          infoWindow.style.visibility = 'visible';
          CreateMarker.openWindow = infoWindow;
        }
      });

      // Reposition bei Resize/Orientationchange
      const onReposition = () => {
        if (CreateMarker.openWindow === infoWindow && infoWindow.style.display === 'block') {
          CreateMarker.positionInfoWindow(marker, infoWindow, stage, map);
        }
      };
      window.addEventListener('resize', onReposition);
      window.addEventListener('orientationchange', onReposition);

      return marker;
    }
  

    static positionInfoWindow(marker, infoWindow, stage, map){
        const padding = 8; // px Abstand zu Rändern

        // Metriken relativ zur MAP (kann sich innerhalb der Stage verschieben)
        const mapRect = map.getBoundingClientRect();
        const markerRect = marker.getBoundingClientRect();

        // Vorläufig sicht- und messbar sicherstellen
        const prevDisplay = infoWindow.style.display;
        const prevVisibility = infoWindow.style.visibility;
        if (getComputedStyle(infoWindow).display === 'none') {
            infoWindow.style.visibility = 'hidden';
            infoWindow.style.display = 'block';
        }

        let windowW = infoWindow.offsetWidth;
        let windowH = infoWindow.offsetHeight;

        // Fallback bei 0-Messwerten
        if (!windowW) { windowW = Math.min(300, map.clientWidth); }
        if (!windowH) { windowH = 150; }

        // Wenn zu breit, begrenzen
        if (windowW > map.clientWidth - padding * 2) {
            infoWindow.style.maxWidth = `${map.clientWidth - padding * 2}px`;
            windowW = map.clientWidth - padding * 2;
        }

        // Horizontal: über Marker zentriert (relativ zur Map)
        let leftPx = (markerRect.left - mapRect.left) + (markerRect.width / 2) - (windowW / 2) + map.scrollLeft;

        // Vertikal: bevorzugt UNTER dem Marker, sonst OBERHALB (relativ zur Map)
        const belowTop = (markerRect.bottom - mapRect.top) + 10 + map.scrollTop;
        const aboveTop = (markerRect.top - mapRect.top) - windowH - 10 + map.scrollTop;
        const totalH = (map.scrollHeight || map.clientHeight);
        let topPx;
        if (belowTop + windowH + padding <= totalH) {
            topPx = belowTop;
        } else {
            topPx = Math.max(padding, aboveTop);
        }

        // Grenzen innerhalb der scrollbaren MAP
        const totalW = (map.scrollWidth || map.clientWidth);

        leftPx = Math.max(padding, Math.min(leftPx, totalW - windowW - padding));
        topPx  = Math.max(padding, Math.min(topPx,  totalH - windowH - padding));

        // Prozentuale Ausgabe basierend auf gesamter MAP-Fläche
        const leftPct = (leftPx / totalW) * 100;
        const topPct  = (topPx  / totalH) * 100;

        infoWindow.style.left = leftPct + '%';
        infoWindow.style.top  = topPct  + '%';

        // Sichtbarkeitsstatus zurücksetzen, falls temporär geändert
        infoWindow.style.display = prevDisplay || 'block';
        infoWindow.style.visibility = prevVisibility || 'visible';
    }

  }
  